const PERSONAL_URL = "/user";
const AUTH_URL = "/auth";
const SHOP_URL = "/shop";
const USER_URL = "/user";
const OWNER = "/owner";
const SELLER = "/seller";
const REFERENCES = "/references";

export default {
	AUTH: AUTH_URL,
	USER: USER_URL,
	LOGIN: `${AUTH_URL}/login`,
	LOGOUT: `${AUTH_URL}/logout`,
	FORGOT_PASSWORD: `${AUTH_URL}/forgot`,
	RESTORE_PASSWORD: `${USER_URL}/password`,
	ALLOW_USER: `${USER_URL}/allow_personal_data_storage`,
	PERSONAL_FULL: `${PERSONAL_URL}/account`,
	PERSONAL_UPD: `${PERSONAL_URL}/password`,
	PERSONAL_DELETE_AVATAR: `${PERSONAL_URL}/delete-avatar`,
	PERSONAL_RECEIPTS: `${PERSONAL_URL}/receipts`,
	INIT: "/init",
	DIST_GIFTS_CATEGORIES: "/distributor/gifts/categories",
	DIST_GIFTS: "/distributor/gifts",
	DIST_ORDERS: "/distributor/orders",
	GIFTS_CATEGORIES: `${SELLER}/gifts/categories`,
	SELLER_ORDERS: `${SELLER}/orders`,
	SELLER_SERVICE_ORDERS: `${SELLER}/service_orders`,
	SELLER_RECEIPTS: `${SELLER}/receipts`,
	SELLER_REPORT: `${SELLER}/export/sales`,
	UPLOAD_VOUCHER: `${SELLER}/receipts/store`,
	UPLOAD_ORDER: `${SELLER}/service_orders/store`,
	CONVERT_PDF_TO_IMAGE: `/tools/files/pdf`,
	DIST_ACTIVATE_GIFT: "/distributor/certificates/issue",
	ACTIVATE_GIFT: `${SELLER}/certificates/issue`,
	REGIONS: `${REFERENCES}/regions`,
	BANNERS: `${REFERENCES}/banners`,
	GOODS: `${REFERENCES}/goods`,
	MORE_BONUSES: `${SELLER}/gifts`,
	GIFTS: `${PERSONAL_URL}/gifts`,
	SHOP: SHOP_URL,
	SHOP_MAIN: `${SHOP_URL}/main`,
	OWNERS: `${REFERENCES}/owners`,
	DOCUMENTS: `${REFERENCES}/documents`,
	FAQ: `${REFERENCES}/faq`,
	OWNER_SALES: `${OWNER}/sales`,
	RULES: "/rules",
	FEEDBACK: "/feedback/send",
	USER_IDENTITIES: "/seller/user_identities",
	DIST_USER_IDENTITIES: "/distributor/user_identities",
	DIST_SALES: "/distributor/sales",
	DIST_ORDER_LIST: "/distributor/service_orders",
	DIST_ORDER_ID_APPROVE: "/distributor/service_orders/approve",
	SALE_POINT_DISTRIBUTOR: "/distributor/sale_points",
	DISTRIBUTOR_OWNERS: "/distributor/owners",
	SALE_POINT_OWNER: "/owner/sale_points",
	SALE_POINTS: `${OWNER}/sale_points`,
	SALE_POINTS_ALL: `${REFERENCES}/sale_points`,
	SELLER: `${OWNER}/sellers`,
	SELLER_SALES: `${SELLER}/sales`,
	DIST_TRANSACTIONS: "/distributor/transactions",
	SELLER_TRANSACTIONS: `${SELLER}/transactions`,
};
